import ModalAddCredit from "../components/ModalAddCredit";
import OrderDetails from "../containers/OrderDetails";
import { CreditContext } from "../contexts/credit";
import React, { useState } from "react";

function OrderView() {
  let [isCreditModalOpen, setCreditModalOpen] = useState(false);
  let [prefilledValue, setPrefilledValue] = useState(null);
  let [meta, setMeta] = useState({});
  return (
    <CreditContext.Provider
      value={{
        isCreditModalOpen,
        setCreditModalOpen: (value, meta) => {
          setCreditModalOpen(value);
          setMeta(meta);
        },
        setPrefilledValue,
        prefilledValue,
        meta,
      }}
    >
      <OrderDetails />
    </CreditContext.Provider>
  );
}

export default OrderView;
